export enum MenuStatus {
  None = 0,
  Completed = 1,
  Incompleted = 2,
}